import $api from "@/frontend/shared/api/axios";

export async function patchExpertSectionNote({
  noteId,
  companyId,
  content,
  organizationId
}: {
  content: string;
  noteId: number;
  companyId: number;
  organizationId: number;
}) {
  const response = await $api.patch(
    `/experts/organizations/${organizationId}/portfolio-companies/${companyId}/notes/${noteId}`,
    { content }
  );
  return response;
}
